/* Colorway Catch header — open/close intent for the dropdown mega-menus,
   mobile drawer + accordion, and search expand. Panels are server-rendered;
   this only toggles classes. Supports multiple header instances. */
(function () {
  "use strict";

  function init(header) {
    var links = header.querySelectorAll(".cc-link[data-menu]");
    var panels = header.querySelectorAll(".cc-panelwrap[data-menu]");
    var scrim = header.querySelector(".cc-scrim");
    var closeTimer = null;
    var openMenu = null;

    function panelFor(id) { return header.querySelector('.cc-panelwrap[data-menu="' + id + '"]'); }

    // Warm dropdown/drawer thumbnails on first intent so panels open instantly.
    // Thumbnails are lazy, so without this they only start downloading on open.
    // Triggered by pointer entering the header (desktop) or opening the drawer
    // (mobile) — zero network cost until the shopper actually engages the menu.
    var warmed = false;
    function warmThumbs() {
      if (warmed) return;
      warmed = true;
      // Only the set the current viewport will actually show (desktop grid vs
      // mobile drawer strip) — avoids fetching both sizes. Flipping to eager
      // loads the real elements now, so the panel opens already populated.
      var mobile = window.matchMedia("(max-width:859px)").matches;
      var sel = mobile ? ".cc-dstrip .cc-thumb img" : ".cc-grid .cc-thumb img";
      header.querySelectorAll(sel).forEach(function (img) {
        img.loading = "eager";
        img.fetchPriority = "low";
        if (!img.complete) { var pre = new Image(); pre.src = img.getAttribute("src") || ""; }
      });
    }
    header.addEventListener("pointerenter", warmThumbs, { once: true });

    function setOpen(id) {
      openMenu = id;
      panels.forEach(function (p) {
        var on = p.getAttribute("data-menu") === id;
        p.classList.toggle("is-open", on);
        if (on) p.removeAttribute("hidden"); else p.setAttribute("hidden", "");
      });
      links.forEach(function (l) {
        var on = l.getAttribute("data-menu") === id;
        l.classList.toggle("is-open", on);
        l.setAttribute("aria-expanded", on ? "true" : "false");
      });
      if (scrim) { if (id) scrim.removeAttribute("hidden"); else scrim.setAttribute("hidden", ""); }
    }

    function enter(id) { clearTimeout(closeTimer); setOpen(id); }
    function leave() { clearTimeout(closeTimer); closeTimer = setTimeout(function () { setOpen(null); }, 150); }
    function stay() { clearTimeout(closeTimer); }

    links.forEach(function (l) {
      var id = l.getAttribute("data-menu");
      l.addEventListener("mouseenter", function () { enter(id); });
      l.addEventListener("focus", function () { warmThumbs(); enter(id); });
      // click: open if closed; if already open, follow through to the collection page
      l.addEventListener("click", function (e) {
        e.preventDefault();
        if (openMenu === id) {
          var href = l.getAttribute("data-href");
          if (href) { window.location.href = href; return; }
          setOpen(null); return;
        }
        setOpen(id);
      });
    });
    panels.forEach(function (p) {
      p.addEventListener("mouseenter", stay);
      p.addEventListener("mouseleave", leave);
    });
    header.addEventListener("mouseleave", leave);
    if (scrim) scrim.addEventListener("mouseenter", function () { setOpen(null); });
    if (scrim) scrim.addEventListener("click", function () { setOpen(null); });

    // search expand (desktop)
    var searchBox = header.querySelector(".cc-bar .cc-search");
    var searchBtn = header.querySelector(".cc-searchbtn");
    if (searchBox && searchBtn) {
      var input = searchBox.querySelector("input");
      searchBtn.addEventListener("click", function () {
        searchBox.classList.add("is-open"); searchBtn.style.display = "none";
        if (input) input.focus();
      });
      if (input) input.addEventListener("blur", function () {
        if (!input.value) { searchBox.classList.remove("is-open"); searchBtn.style.display = ""; }
      });
    }

    // mobile drawer
    var drawer = header.querySelector(".cc-drawer");
    var mscrim = header.querySelector(".cc-mscrim");
    function openDrawer() { warmThumbs(); if (drawer) drawer.classList.add("is-open"); if (mscrim) mscrim.classList.add("is-open"); }
    function closeDrawer() { if (drawer) drawer.classList.remove("is-open"); if (mscrim) mscrim.classList.remove("is-open"); }
    var menuBtn = header.querySelector(".cc-menubtn");
    if (menuBtn) menuBtn.addEventListener("click", openDrawer);
    if (mscrim) mscrim.addEventListener("click", closeDrawer);
    var dclose = header.querySelector(".cc-dclose");
    if (dclose) dclose.addEventListener("click", closeDrawer);

    // drawer accordion
    header.querySelectorAll(".cc-drow[data-menu]").forEach(function (row) {
      var id = row.getAttribute("data-menu");
      var strip = header.querySelector('.cc-dstrip[data-menu="' + id + '"]');
      row.addEventListener("click", function () {
        var willOpen = !row.classList.contains("is-open");
        header.querySelectorAll(".cc-drow.is-open").forEach(function (r) { r.classList.remove("is-open"); });
        header.querySelectorAll(".cc-dstrip.is-open").forEach(function (s) { s.classList.remove("is-open"); });
        if (willOpen) { row.classList.add("is-open"); if (strip) strip.classList.add("is-open"); }
      });
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") { setOpen(null); closeDrawer(); }
    });
  }

  function boot() { document.querySelectorAll(".cc-header[data-cc]").forEach(init); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
